import { Buffer } from 'buffer';
import { generateKey, xor } from './lib/xor'
import log from './lib/log-no-src'

export function showEmail() {
    const key = generateKey(16)
    const xorString = xor(Buffer.from('cmVlZEBwbHVzcmVlZC5jb20NCg==', 'base64').toString('utf-8'), key);
    ;(window as any)['eStr'] = xorString
    ;(window as any)['eKey'] = key
    log("The string is at window.eStr.");
    log("The key is at window.eKey.");
    log('Hopefully not too hard, right...?')

    import(/* webpackChunkName: 'swal2' */'sweetalert2').then(({ default: Swal }) => {
        Swal.fire({
            title: 'Email Address',
            customClass: {
                popup: 'animated bounceIn'
            },
            //text: `Email address: ${Buffer.from("cmVlZEBwbHVzcmVlZC5jb20NCg==", 'base64')}`
            html: 'You can email me at my name @ this domain.<br>Failing that, take a look in the console.'
        });
    })
}